import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import type { ReportingService } from "@/features/reporting/api/endpoints";
import { reportingEndpoints } from "@/features/reporting/api/endpoints";
import { parseGauges } from "@/features/reporting/api/parse";

/** Jauges d'état instantané (`GET .../Reporting/gauges`). */
export const useReportingGauges = (
  service: ReportingService,
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.REPORTING_GAUGES(service),
    queryFn: async () => {
      const raw = await fetchDataGet<unknown>({
        url: reportingEndpoints[service].gauges,
      });
      return parseGauges(raw);
    },
    retry: (failureCount, error) =>
      !/401|403/.test(error?.message ?? "") && failureCount < 1,
    staleTime: 60 * 1000,
    enabled: enabled && Boolean(service),
  });
